import axios from "axios";
import { fetchConfig } from "../utils/fetch";

const axiosInstance = axios.create();

let isRefreshing = false;
let refreshPromise: Promise<string> | null = null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let failedQueue: Array<{ resolve: (token: string) => void; reject: (error: any) => void }> = [];

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });
  failedQueue = [];
};

// Token refresh logic
const refreshToken = async () => {
  if (!isRefreshing) {
    isRefreshing = true;
    try {
      const refresh_token = localStorage.getItem("refreshToken");
      const config = await fetchConfig();
      const baseURL = config?.API_URL;

      const response = await axios.post(`${baseURL}/auth/refresh-token`, {
        refresh_token,
        grant_type: "refresh_token",
        client_id: import.meta.env.VITE_APP_CLIENT_ID,
        client_secret: import.meta.env.VITE_APP_CLIENT_SECRET,
      });

      const access_token_new = response?.data?.data.access_token;
      const expires_in_new = response?.data?.data.expires_in;
      const refresh_token_new = response?.data?.data.refresh_token;

      localStorage.setItem("accessToken", access_token_new);
      localStorage.setItem("tokenExpiresAt", `${Date.now() + expires_in_new * 1000}`);
      localStorage.setItem("refreshToken", refresh_token_new);

      processQueue(null, access_token_new);
      return access_token_new;
    } catch (error) {
      processQueue(error, null);
      throw error;
    } finally {
      isRefreshing = false;
      refreshPromise = null;
    }
  }

  return refreshPromise!;
};

axiosInstance.interceptors.request.use(
  async (config) => {
    const accessToken = localStorage.getItem("accessToken");
    const expiresAt = localStorage.getItem("tokenExpiresAt");

    if (accessToken && expiresAt && Date.now() > parseInt(expiresAt) - 5 * 60 * 1000) {
      if (!refreshPromise) {
        refreshPromise = refreshToken();
      }

      const token = await refreshPromise;
      config.headers.Authorization = `Bearer ${token}`;
    } else if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

export const ensureTokenRefreshed = async () => {
  if (refreshPromise) {
    await refreshPromise;
  }
};

export default axiosInstance;
